import { getkwargs } from "../../utilities/functions";
import { onChange } from "../onchange";

const getArgoumentsForPartnerId = ({ partner_id = false, uid, company_id }) => [
  [],
  {
    authorized_transaction_ids: [[6, false, []]],
    disabled_confirm_button: false,
    state: "draft",
    picking_ids: [],
    delivery_count: 0,
    invoice_count: 0,
    name: "New",
    partner_id: partner_id ? Number(partner_id) : false,
    delivery_set: false,
    is_all_service: true,
    recompute_delivery_price: false,
    partner_invoice_id: false,
    partner_shipping_id: false,
    sale_order_template_id: false,
    validity_date: false,
    date_order: "2024-04-14 11:54:31",
    show_update_pricelist: false,
    pricelist_id: false,
    currency_id: false,
    payment_term_id: false,
    payment_status: false,
    order_line: [],
    note: "",
    amount_untaxed: 0,
    amount_tax: 0,
    amount_total: 0,
    sale_order_option_ids: [],
    user_id: uid,
    process_manual_confirm: false,
    team_id: 1,
    website_id: false,
    is_abandoned_cart: false,
    cart_recovery_email_sent: false,
    company_id,
    require_signature: true,
    require_payment: true,
    reference: false,
    client_order_ref: false,
    tag_ids: [[6, false, []]],
    related_enable_contact_map_support: false,
    location_map_latitude: 0,
    location_map_longitude: 0,
    location_map_url: false,
    fiscal_position_id: false,
    analytic_account_id: false,
    invoice_status: "no",
    warehouse_id: 1,
    incoterm: false,
    picking_policy: "direct",
    commitment_date: false,
    expected_date: false,
    show_json_popover: false,
    json_popover: false,
    effective_date: false,
    origin: false,
    opportunity_id: false,
    campaign_id: false,
    medium_id: false,
    source_id: false,
    signed_by: false,
    signed_on: false,
    signature: false,
    __last_update: false,
    message_follower_ids: [],
    activity_ids: [],
    message_ids: [],
  },
  "partner_id",
  {
    authorized_transaction_ids: "",
    disabled_confirm_button: "",
    state: "1",
    picking_ids: "1",
    delivery_count: "",
    invoice_count: "",
    name: "",
    partner_id: "1",
    delivery_set: "",
    is_all_service: "",
    recompute_delivery_price: "1",
    partner_invoice_id: "",
    partner_shipping_id: "1",
    sale_order_template_id: "1",
    validity_date: "",
    date_order: "1",
    show_update_pricelist: "",
    pricelist_id: "1",
    currency_id: "1",
    payment_term_id: "",
    payment_status: "",
    order_line: "1",
    "order_line.display_type": "",
    "order_line.sequence": "",
    "order_line.product_uom_category_id": "",
    "order_line.product_updatable": "",
    "order_line.product_id": "1",
    "order_line.invoice_status": "1",
    "order_line.qty_to_invoice": "1",
    "order_line.qty_delivered_manual": "1",
    "order_line.qty_delivered_method": "1",
    "order_line.price_total": "1",
    "order_line.price_tax": "",
    "order_line.price_subtotal": "",
    "order_line.product_uom_readonly": "",
    "order_line.product_uom_qty": "1",
    "order_line.product_uom": "1",
    "order_line.product_type": "1",
    "order_line.virtual_available_at_date": "",
    "order_line.qty_available_today": "",
    "order_line.free_qty_today": "",
    "order_line.scheduled_date": "",
    "order_line.forecast_expected_date": "",
    "order_line.warehouse_id": "",
    "order_line.qty_to_deliver": "",
    "order_line.is_mto": "",
    "order_line.display_qty_widget": "",
    "order_line.qty_delivered": "1",
    "order_line.qty_invoiced": "1",
    "order_line.product_packaging": "1",
    "order_line.recompute_delivery_price": "",
    "order_line.is_delivery": "1",
    "order_line.price_unit": "1",
    "order_line.tax_id": "1",
    "order_line.discount": "1",
    "order_line.customer_lead": "1",
    "order_line.route_id": "1",
    "order_line.analytic_tag_ids": "",
    "order_line.name": "",
    "order_line.invoice_lines": "1",
    "order_line.state": "1",
    "order_line.company_id": "",
    "order_line.product_template_id": "",
    "order_line.currency_id": "",
    note: "",
    amount_untaxed: "",
    amount_tax: "",
    amount_total: "",
    sale_order_option_ids: "",
    "sale_order_option_ids.product_id": "1",
    "sale_order_option_ids.name": "",
    "sale_order_option_ids.quantity": "1",
    "sale_order_option_ids.product_uom_category_id": "",
    "sale_order_option_ids.uom_id": "1",
    "sale_order_option_ids.price_unit": "",
    "sale_order_option_ids.discount": "",
    "sale_order_option_ids.is_present": "",
    "sale_order_option_ids.sequence": "",
    user_id: uid,
    process_manual_confirm: "",
    team_id: "1",
    website_id: "1",
    is_abandoned_cart: "",
    cart_recovery_email_sent: "",
    company_id: company_id,
    require_signature: "",
    require_payment: "",
    reference: "",
    client_order_ref: "",
    tag_ids: "",
    related_enable_contact_map_support: "",
    location_map_latitude: "",
    location_map_longitude: "",
    location_map_url: "",
    fiscal_position_id: "1",
    analytic_account_id: "",
    invoice_status: "",
    warehouse_id: "1",
    incoterm: "",
    picking_policy: "1",
    commitment_date: "1",
    expected_date: "",
    show_json_popover: "",
    json_popover: "",
    effective_date: "",
    origin: "",
    opportunity_id: "",
    campaign_id: "",
    medium_id: "",
    source_id: "",
    signed_by: "",
    signed_on: "",
    signature: "",
    __last_update: "",
    message_follower_ids: "",
    "message_follower_ids.res_model": "",
    "message_follower_ids.res_id": "",
    "message_follower_ids.partner_id": "",
    "message_follower_ids.channel_id": "",
    activity_ids: "",
    "activity_ids.res_name": "",
    "activity_ids.activity_type_id": "1",
    "activity_ids.summary": "",
    "activity_ids.date_deadline": "",
    message_ids: "",
    "message_ids.date": "",
    "message_ids.subject": "",
    "message_ids.author_id": "",
    "message_ids.model": "",
    "message_ids.res_id": "",
  },
];
const getArgoumentsForCustomerID = ({ customer_id, uid, company_id }) => {
  return [
    [],
    {
      authorized_transaction_ids: [[6, false, []]],
      disabled_confirm_button: false,
      state: "draft",
      picking_ids: [],
      delivery_count: 0,
      invoice_count: 0,
      name: "New",
      partner_id: customer_id,
      delivery_set: false,
      is_all_service: true,
      recompute_delivery_price: false,
      partner_invoice_id: false,
      partner_shipping_id: false,
      sale_order_template_id: false,
      validity_date: false,
      date_order: "2024-04-17 13:42:40",
      show_update_pricelist: false,
      pricelist_id: false,
      currency_id: false,
      payment_term_id: false,
      payment_status: false,
      order_line: [],
      note: "",
      amount_untaxed: 0,
      amount_tax: 0,
      amount_total: 0,
      sale_order_option_ids: [],
      user_id: uid,
      process_manual_confirm: false,
      team_id: company_id,
      website_id: false,
      is_abandoned_cart: false,
      cart_recovery_email_sent: false,
      company_id: company_id,
      require_signature: true,
      require_payment: true,
      reference: false,
      client_order_ref: false,
      tag_ids: [[6, false, []]],
      related_enable_contact_map_support: false,
      location_map_latitude: 0,
      location_map_longitude: 0,
      location_map_url: false,
      fiscal_position_id: false,
      analytic_account_id: false,
      invoice_status: "no",
      warehouse_id: 1,
      incoterm: false,
      picking_policy: "direct",
      commitment_date: false,
      expected_date: false,
      show_json_popover: false,
      json_popover: false,
      effective_date: false,
      origin: false,
      opportunity_id: false,
      campaign_id: false,
      medium_id: false,
      source_id: false,
      signed_by: false,
      signed_on: false,
      signature: false,
      __last_update: false,
      message_follower_ids: [],
      activity_ids: [],
      message_ids: [],
    },
    "partner_id",
    {
      authorized_transaction_ids: "",
      disabled_confirm_button: "",
      state: "1",
      picking_ids: "1",
      delivery_count: "",
      invoice_count: "",
      name: "",
      partner_id: "1",
      delivery_set: "",
      is_all_service: "",
      recompute_delivery_price: "1",
      partner_invoice_id: "",
      partner_shipping_id: "1",
      sale_order_template_id: "1",
      validity_date: "",
      date_order: "1",
      show_update_pricelist: "",
      pricelist_id: "1",
      currency_id: "1",
      payment_term_id: "",
      payment_status: "",
      order_line: "1",
      "order_line.display_type": "",
      "order_line.sequence": "",
      "order_line.product_uom_category_id": "",
      "order_line.product_updatable": "",
      "order_line.product_id": "1",
      "order_line.invoice_status": "1",
      "order_line.qty_to_invoice": "1",
      "order_line.qty_delivered_manual": "1",
      "order_line.qty_delivered_method": "1",
      "order_line.price_total": "1",
      "order_line.price_tax": "",
      "order_line.price_subtotal": "",
      "order_line.product_uom_readonly": "",
      "order_line.product_uom_qty": "1",
      "order_line.product_uom": "1",
      "order_line.product_type": "1",
      "order_line.virtual_available_at_date": "",
      "order_line.qty_available_today": "",
      "order_line.free_qty_today": "",
      "order_line.scheduled_date": "",
      "order_line.forecast_expected_date": "",
      "order_line.warehouse_id": "",
      "order_line.qty_to_deliver": "",
      "order_line.is_mto": "",
      "order_line.display_qty_widget": "",
      "order_line.qty_delivered": "1",
      "order_line.qty_invoiced": "1",
      "order_line.product_packaging": "1",
      "order_line.recompute_delivery_price": "",
      "order_line.is_delivery": "1",
      "order_line.price_unit": "1",
      "order_line.tax_id": "1",
      "order_line.discount": "1",
      "order_line.customer_lead": "1",
      "order_line.route_id": "1",
      "order_line.analytic_tag_ids": "",
      "order_line.name": "",
      "order_line.invoice_lines": "1",
      "order_line.state": "1",
      "order_line.company_id": "",
      "order_line.product_template_id": "",
      "order_line.currency_id": "",
      note: "",
      amount_untaxed: "",
      amount_tax: "",
      amount_total: "",
      sale_order_option_ids: "",
      "sale_order_option_ids.product_id": "1",
      "sale_order_option_ids.name": "",
      "sale_order_option_ids.quantity": "1",
      "sale_order_option_ids.product_uom_category_id": "",
      "sale_order_option_ids.uom_id": "1",
      "sale_order_option_ids.price_unit": "",
      "sale_order_option_ids.discount": "",
      "sale_order_option_ids.is_present": "",
      "sale_order_option_ids.sequence": "",
      user_id: uid,
      process_manual_confirm: "",
      team_id: "1",
      website_id: "1",
      is_abandoned_cart: "",
      cart_recovery_email_sent: "",
      company_id: company_id,
      require_signature: "",
      require_payment: "",
      reference: "",
      client_order_ref: "",
      tag_ids: "",
      related_enable_contact_map_support: "",
      location_map_latitude: "",
      location_map_longitude: "",
      location_map_url: "",
      fiscal_position_id: "1",
      analytic_account_id: "",
      invoice_status: "",
      warehouse_id: "1",
      incoterm: "",
      picking_policy: "1",
      commitment_date: "1",
      expected_date: "",
      show_json_popover: "",
      json_popover: "",
      effective_date: "",
      origin: "",
      opportunity_id: "",
      campaign_id: "",
      medium_id: "",
      source_id: "",
      signed_by: "",
      signed_on: "",
      signature: "",
      __last_update: "",
      message_follower_ids: "",
      "message_follower_ids.res_model": "",
      "message_follower_ids.res_id": "",
      "message_follower_ids.partner_id": "",
      "message_follower_ids.channel_id": "",
      activity_ids: "",
      "activity_ids.res_name": "",
      "activity_ids.activity_type_id": "1",
      "activity_ids.summary": "",
      "activity_ids.date_deadline": "",
      message_ids: "",
      "message_ids.date": "",
      "message_ids.subject": "",
      "message_ids.author_id": "",
      "message_ids.model": "",
      "message_ids.res_id": "",
    },
  ];
};

const getArgoumentsForProductId = ({
  product_id,
  company_id,
  uid,
  values = {},
}) => [
  [],
  {
    sequence: 10,
    display_type: false,
    product_uom_category_id: false,
    product_updatable: true,
    product_id: Number(product_id),
    product_template_id: false,
    name: values.name || false,
    analytic_tag_ids: [[6, false, []]],
    route_id: false,
    product_uom_qty: 1,
    qty_delivered: 0,
    product_type: false,
    virtual_available_at_date: 0,
    qty_available_today: 0,
    free_qty_today: 0,
    scheduled_date: false,
    forecast_expected_date: false,
    warehouse_id: 1,
    qty_to_deliver: 1,
    is_mto: false,
    display_qty_widget: false,
    qty_delivered_manual: 0,
    qty_delivered_method: "manual",
    qty_invoiced: 0,
    qty_to_invoice: 0,
    product_uom_readonly: false,
    product_uom: false,
    customer_lead: 0,
    product_packaging: false,
    recompute_delivery_price: false,
    is_delivery: false,
    price_unit: values?.price_unit || 1,
    discount: values?.discount || 0,
    price_subtotal: 0,
    state: "draft",
    invoice_status: "no",
    currency_id: false,
    price_tax: 0,
    company_id: company_id,
    ...(values || {}),
    tax_id: [[6, false, values.tax_id ? [values.tax_id] : []]],
  },
  "product_id",
  {
    sequence: "",
    display_type: "",
    product_uom_category_id: "",
    product_updatable: "",
    product_id: "1",
    product_template_id: "",
    name: "",
    analytic_tag_ids: "",
    route_id: "1",
    product_uom_qty: "1",
    qty_delivered: "1",
    product_type: "1",
    virtual_available_at_date: "",
    qty_available_today: "",
    free_qty_today: "",
    scheduled_date: "",
    forecast_expected_date: "",
    warehouse_id: "",
    qty_to_deliver: "",
    is_mto: "",
    display_qty_widget: "",
    qty_delivered_manual: "1",
    qty_delivered_method: "1",
    qty_invoiced: "1",
    qty_to_invoice: "1",
    product_uom_readonly: "",
    product_uom: "1",
    customer_lead: "1",
    product_packaging: "1",
    recompute_delivery_price: "",
    is_delivery: "1",
    price_unit: "1",
    tax_id: "1",
    discount: "1",
    price_subtotal: "",
    price_total: "1",
    state: "1",
    invoice_status: "1",
    currency_id: "",
    price_tax: "",
    company_id: "",
  },
];

export const onChangeSelectOrder = async ({
  partner_id = false,
  product_id = false,
  customer_id = false,
  tag_ids = [],
  context,
  company_id,
  model = "sale.order",
  values = null,
}) => {
  let args = [{}, {}];
  if (partner_id || tag_ids) {
    args = getArgoumentsForPartnerId({
      partner_id,
      company_id,
      uid: context.uid,
    });
  }
  if (customer_id) {
    args = getArgoumentsForCustomerID({
      customer_id,
      uid: context.uid,
      company_id,
    });
  }
  if (product_id) {
    args = getArgoumentsForProductId({
      product_id,
      company_id,
      uid: context.uid,
      values,
    });
  }
  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params: {
      args,
      model,
      method: "onchange",

      ...getkwargs({ context, company_id, model, view_type: "form" }),
    },
  });
  return onChange(raw, model);
};
